exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stop-all_stop-all_15h2t {\n    width: 21px;\n    height: 21px;\n    /* padding: 0.375rem;\n    border-radius: 0.25rem; */\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n    -webkit-transition: 0.2s ease-out;\n    transition: 0.2s ease-out;\n}\n\n.stop-all_stop-all_15h2t {\n    /*opacity: 0.5;*/\n}\n\n.stop-all_stop-all_15h2t:hover {\n    -webkit-transform: scale(1.2);\n        -ms-transform: scale(1.2);\n            transform: scale(1.2);\n}\n\n.stop-all_stop-all_15h2t.stop-all_is-active_PEgCP {\n    opacity: 1;\n}\n", ""]);

// exports
exports.locals = {
	"stop-all": "stop-all_stop-all_15h2t",
	"stopAll": "stop-all_stop-all_15h2t",
	"is-active": "stop-all_is-active_PEgCP",
	"isActive": "stop-all_is-active_PEgCP"
};